import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { PostModel, PostViewResponse } from "@/types/post";
import postApi from "@/services/modules/post";
import postCommentApi from "@/services/modules/postComment";
import { UserModel } from "@/types/common";

const slice = createSlice({
  name: "post",
  initialState: {
    postList: [],
    userList: [],
    postViewData: {} as PostViewResponse,
  } as PostState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(postApi.endpoints.getPosts.matchPending, (state) => {
      return {
        ...state,
        postList: [],
      };
    });
    builder.addMatcher(
      postApi.endpoints.postView.matchFulfilled,
      (state, { payload }) => {
        return {
          ...state,
          postViewData: payload,
        };
      }
    );
    builder.addMatcher(
      postApi.endpoints.getPosts.matchFulfilled,
      (state, { payload }) => {
        return {
          ...state,
          postList: payload,
        };
      }
    );
    builder.addMatcher(
      postApi.endpoints.getPostUsers.matchFulfilled,
      (state, { payload }) => {
        return {
          ...state,
          userList: payload,
        };
      }
    );
    builder.addMatcher(
      postApi.endpoints.deletePost.matchFulfilled,
      (state, { payload }) => {
        return {
          ...state,
          postList: state.postList.filter((c) => c.postId != payload),
        };
      }
    );
    builder.addMatcher(
      isAnyOf(
        postApi.endpoints.likeDislikePost.matchFulfilled,
        postApi.endpoints.addEditPost.matchFulfilled
      ),
      (state, { payload }) => {
        let postList = state.postList.slice();
        const index = postList.findIndex((c) => c.postId == payload[0].postId);
        if (index > -1) {
          postList[index] = payload[0];
        } else {
          postList.splice(0, 0, ...payload);
        }
        return {
          ...state,
          postList: postList,
        };
      }
    );
    builder.addMatcher(
      postCommentApi.endpoints.addEditComment.matchFulfilled,
      (state, { payload: { posts } }) => {
        let postList = state.postList.slice();
        const index = postList.findIndex((c) => c.postId == posts[0].postId);
        if (index > -1) {
          postList[index] = posts[0];
        } else {
          postList.splice(0, 0, ...posts);
        }
        return {
          ...state,
          postList: postList,
        };
      }
    );
  },
});

export default slice.reducer;

export interface PostState {
  postList: PostModel[];
  userList: UserModel[];
  postViewData: PostViewResponse;
}
